import { Field } from 'formik'
import { ChangeEvent, FC, useState } from 'react'
import Svg from '../../svg'
import { StyleErrorMessage, StyleFormWrapper, StyleLabel } from '../style'
import { StyleIconWrapper, StyleInput } from './style'
interface InputProps {
  label?: string
  name: string
  placeholder?: string
  editable?: boolean
  onChangeText?: (text: string) => void
  styleInput?: string
  styleLabel?: string
  styleWrapper?: string
}
const Password: FC<InputProps> = ({
  label,
  name,
  styleLabel,
  styleWrapper,
  ...restProps
}) => {
  const [focus, setFocus] = useState<boolean>(false)
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const handleChange = ({ form, value }: any) => {
    form.setFieldValue(name, value)
  }
  return (
    <Field name={name}>
      {({ form, meta }: any) => {
        const hasError = !!meta.touched && !!meta.error
        return (
          <StyleFormWrapper styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleInput
              isFocus={focus}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              hasError={hasError}
              type={!isVisible ? 'password' : 'text'}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                handleChange({
                  form,
                  value: event.target.value,
                })
              }}
              {...restProps}
            />
            <StyleIconWrapper onClick={() => setIsVisible(!isVisible)}>
              {!!isVisible ? <Svg src="eyeOff" /> : <Svg src="eye" />}
            </StyleIconWrapper>
            {!!hasError && <StyleErrorMessage>{meta?.error}</StyleErrorMessage>}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default Password
